import dayjs from 'dayjs';

export const DEFAULT_LOG_QUERY = {
  pageSize: 10,
  pageNumber: 1,
  eventType: 'AllUser',
  startTime: dayjs().subtract(5, 'month').startOf('month').unix(),
  endTime: dayjs().endOf('day').unix(),
  keyword: '',
};
